import React, { useContext } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import { Theme } from '../contexts/themeContext.js';
import { GlobalTheme } from "../../layouts/theme";

export default function ConfirmDialog(props) {
    const { theme } = useContext(Theme);
    const currentTheme = GlobalTheme[theme];

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.close}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{props.message}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onConfirm} variant="contained" color="primary" size="small" style={{ background: currentTheme.secondary, width: "80px" }} startIcon={<CheckIcon />}>Yes</Button>
                    <Button onClick={props.close} variant="contained" color="secondary" size="small" style={{ width: "80px", marginRight: "10px" }} startIcon={<CancelIcon />} autoFocus>No</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
